import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PageTemplate from '../../ui/page_template';
import { withTranslation } from 'react-i18next';
import {pages as pagesLang} from '../../../language';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import HelperText from '../../simple/helper_text';
import {changeTwoFactorLoginStatus, settingsPageInit} from '@componentDP/js_react/redux/actions/settings';
import LoadingZajavls from '../../skeletons/loading_zajavls';
import ChangePassword from './ChangePassword';
import Typography from '@material-ui/core/Typography';

class SettingsPage extends React.Component {
    constructor(props) {
        super(props);
        this.props.settingsPageInit();
    }

    twoFactorLoginHandleChange = (e) => {
        const checked = e.target.checked;
        this.props.changeTwoFactorLoginStatus(checked);
    };

    render() {
        const {settingsPageLoaded, twoFactorLogin, t} = this.props;
        const pageContent = !settingsPageLoaded
            ? <LoadingZajavls/>
            : <React.Fragment>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h5">
                            {t('auth_confirm')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <HelperText message={t('account_secure_info')}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="checkedB"
                                    color="primary"
                                    checked={twoFactorLogin}
                                    onChange={(e) => this.twoFactorLoginHandleChange(e)}
                                />
                            }
                            label={t('is_on')}
                            labelPlacement="start"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ChangePassword />
                    </Grid>
                </Grid>
            </React.Fragment>;
        return (
            <PageTemplate title={t('settings')}>
                <Grid container spacing={2}>
                    {pageContent}
                </Grid>
            </PageTemplate>
        );
    }
}

const mapStateToProps = state => {
    const {apiDomainAuth, settingsPageLoaded, twoFactorLogin} = state;
    return {
        apiDomainAuth,
        settingsPageLoaded,
        twoFactorLogin,
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    settingsPageInit,
    changeTwoFactorLoginStatus,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SettingsPage));
